import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { Terminal } from '@payment-terminals/interfaces/terminal';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';
import CheckCashdroStatusModal from '@payment-terminals/components/modals/check-cashdro-status-modal.vue';

@Component({
  name: 'bpc-terminal-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    'bpc-drawer-modal': DrawerModal,
    'bpc-check-cashdro-status-modal': CheckCashdroStatusModal,
  },
})
export default class TerminalTable extends mixins(AbstractTable) {
  $refs: AbstractTable['$refs'] & {
    updateWipayTerminalConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    checkCashdroStatusModal: InstanceType<typeof CheckCashdroStatusModal> & {
      openModal(): void;
    };
  };
  @Prop(String) readonly displayConfigName: string;
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;

  public entity: Terminal = null;
  public entityName = 'terminal';
  public pluralEntityName = 'terminals';
  public permissionEntityNameToUse = 'terminals';

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'paginationLoaded',
    'orderLoaded',
    'filtersLoaded',
    'urlParametersLoaded',
  ];

  /* DATA for check cashdro status modal */
  public showCheckCashdroStatusModal: boolean = false;

  customRowActions = {
    updateWipayTerminal: {
      activated: false,
      type: 'action',
      icon: 'sync',
      show: false,
      event: 'update-wipay-terminal',
      text: 'updateWipayTerminal',
      permissions: ['update'],
    },
    checkCashdroStatus: {
      activated: false,
      type: 'action',
      icon: 'sync',
      show: false,
      event: 'check-cashdro-satus',
      text: 'checkCashdroStatus',
      permissions: ['update'],
    },
  };

  get rowActions() {
    return {
      ...this.customRowActions,
      ...this.defaultRowActions,
    };
  }

  get updateWipayTerminalConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'update-wipay-terminal-modal',
      title: this.$t('global.modals.update_wipay_terminal.title'),
      body: this.$t('global.modals.update_wipay_terminal.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.accept') as string,
    };
  }

  extendUpdateRowActions(entity: any) {
    if (
      this.tableIsNotFilteredByTrashedElements() &&
      entity.status === 'active' &&
      entity.type === 'wipay'
    ) {
      entity.actions.updateWipayTerminal.show = true;
    }
    if (
      this.tableIsNotFilteredByTrashedElements() &&
      entity.status === 'active' &&
      entity.type === 'cashdro'
    ) {
      entity.actions.checkCashdroStatus.show = true;
      entity.actions.checkCashdroStatus.activated = true;
    }
  }
  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'update-wipay-terminal':
        this.onUpdateWipayTerminal($event.item.item);
        break;
      case 'check-cashdro-satus':
        this.onCheckCashdroStatus($event.item.item);
        break;
    }
  }

  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
    this.refreshCenterTerminals();
  }
  onSuccessDelete() {
    this.$refs.deleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
    this.refreshCenterTerminals();
  }
  onSuccessRecover() {
    this.$refs.recoverConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
    this.refreshCenterTerminals();
  }
  onSuccessBulkSoftDelete() {
    this.$refs.bulkSoftDeleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
    this.refreshCenterTerminals();
  }
  onSuccessBulkDelete() {
    this.$refs.bulkDeleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
    this.refreshCenterTerminals();
  }
  onSuccessBulkRecover() {
    this.$refs.bulkRecoverConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
    this.refreshCenterTerminals();
  }
  onUpdateWipayTerminal($event) {
    this.$refs.updateWipayTerminalConfirmationModal.onOpenModal($event.id);
  }
  onCheckCashdroStatus($event) {
    console.log('onCheckCashdroStatus: ');
    console.log($event);
    this.entity = $event;
    this.$refs.checkCashdroStatusModal.openModal(this.entity);
  }

  updateWipayTerminal($event) {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('terminal');
    this.$bpcApi
      .post(basePath + '/wipay/update-terminal', {
        id: $event['entityIdOrIds'],
      })
      .subscribe(
        res => {
          this.$refs.updateWipayTerminalConfirmationModal.onCloseModal();
        },
        error => {
          this.$bpcMessage.showErrorMessage({ text: 'global.send_invoice.single.error' });
        },
      );
  }

  refreshCenterTerminals(): void {
    this.$store.dispatch('paymentTerminals/getTerminals');
  }
  /* Lifecycle hooks */

  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
